import React from 'react';
import MiddleStarIcon from 'assets/img/icons/bingo-star.svg?react';

export default function BingoMiddleStar() {
  return (
    <div>
      <MiddleStarIcon width={35} height={35} />
    </div>
  );
}
